import { observer } from 'mobx-react'
import React, { useState, useEffect } from 'react'
import { memberMobx, invoiceMobx, decorationMobx, storeMobx } from '@mobxStore'
import { useHistoryNew, toast } from '@utils'
import { MktController } from '@ctrls/index'
import { getGiftCardName } from '@common/utils/giftcard'
import './index.scss'
import { permissionMobx } from '@mobx/app'

interface IProps { }

const Entry: React.FC<IProps> = (props: IProps) => {
  const cnKey: any[] = ['myInvoice', 'groupCoupon']
  const usKey: any[] = ['myGreditCard']
  const entryMap: any = {
    applyMemberCard: {
      path: '/memberCard',
      name: i18n.t('pageName.card'),
      needLogin: true,
      needMember: true,
    },
    myCoupon: {
      path: '/iCoupon',
      name: i18n.t('mkt.coupon.myCoupon'),
      needLogin: true,
      needMember: true,
    },
    redeem: {
      path: '/redeem',
      name: i18n.t('mkt.redeem.pointRedeem'),
      needLogin: true,
      needMember: true,
    },
    // receiveCoupon: {
    //   path: '/my/couponGet',
    //   name: i18n.t('mkt.member.couponColl'),
    //   needLogin: true,
    //   needMember: true,
    // },
    groupCoupon: {
      path: '/groupBuy',
      name: i18n.t('mkt.groupBuy.groupBuy2'),
      needLogin: true,
      needMember: true,
    },
    myGiftCard: {
      path: '/iGc',
      name: getGiftCardName('mkt.giftCard.myGiftCard'),
      needLogin: true,
      needMember: false,
    },
    myGreditCard: {
      path: '/iBc',
      name: i18n.t('pay.bankCardManage'),
      needLogin: true,
      needMember: false,
    },
    myInvoice: {
      path: '/myInvoice',
      name: i18n.t('invoice.myInvoice'),
      needLogin: true,
      needMember: true,
    },
    order: {
      path: '/orders/2',
      name: i18n.t('common.orders'),
      needLogin: true,
      needMember: false,
    },
    setting: {
      path: '/my/setting',
      name: i18n.t('pageName.setting'),
      needLogin: true,
      needMember: false,
    },
    mcollect: {
      path: '/mcollect',
      name: i18n.t('common.mcollect'),
      needLogin: true,
      needMember: false,
    }
  }
  const history = useHistoryNew()
  const [showEntry, setShowEntry] = useState<boolean>(false)
  const [entryArr, setEntryArr] = useState<any[]>([])
  const { mktDecorates } = decorationMobx
  const { openState } = memberMobx
  const handleGo = (e: any, path: string, needLogin: boolean, needMember: boolean) => {
    e && e.stopPropagation()
    if (path === '/myInvoice' && storeMobx.brand.extInfo.mobileTicketBySelf === '0') {
      toast({ message: i18n.t('invoice.noAuth') })
      return
    }
    MktController.checkLogin(history, needLogin, needMember).then(() => {
      history.push(path)
    })
  }
  useEffect(() => {
    const cnFilter: any[] = invoiceMobx.storeInvoiceStatus ? usKey : ['myInvoice', ...usKey]
    let entryData = mktDecorates.entry.filter((item: any) => {
      return !(window.bo === 'cn' ? cnFilter.includes(item.key) : cnKey.includes(item.key)) && openState[item.key] !== false
    })
    if (permissionMobx.checkAuthToKey('electronic_invoice')) {
      entryData = entryData.filter(item => item.key !== 'myInvoice')
    }
    setEntryArr(entryData)
  }, [mktDecorates.entry, invoiceMobx.storeInvoiceStatus, openState])
  useEffect(() => {
    if (mktDecorates?.memberTemp === 'newplan' || mktDecorates?.memberTemp === 'threeTemp') {
      if (mktDecorates.entryInfo.showCnt !== 'all' && entryArr.length > Number(mktDecorates.entryInfo.showCnt)) {
        setShowEntry(false)
      } else {
        setShowEntry(true)
      }
    } else {
      entryArr.length > 8 ? setShowEntry(false) : setShowEntry(true)
    }
  }, [entryArr])
  return (
    <>
      {
        (mktDecorates?.memberTemp === 'newplan' || mktDecorates?.memberTemp === 'threeTemp') ? (
          <div className='mkt-entry-vertical'>
            {
              (mktDecorates?.memberTemp === 'threeTemp' ? entryArr.filter((i: any) => i?.status !== 'disable') : entryArr).slice(0, showEntry ? mktDecorates.entry.length : Number(mktDecorates.entryInfo.showCnt)).map((item: any) => {
                const mapItem: any = entryMap[item.key]
                return mapItem && (
                  <div data-cypid='mmgToEntry' key={item.key} className='mkt-entry-item' onClick={(e: any) => handleGo(e, mapItem.path, mapItem.needLogin, mapItem.needMember)}>
                    {
                      item.type === 'icon' ? (
                        <div className='mkt-entry-icon'>
                          <i style={{ color: item.color }} className={`iconfont icon-${item.value}`}></i>
                        </div>
                      ) : (
                        <div className='mkt-entry-icon' style={{ backgroundImage: `Url(${item.value})` }}></div>
                      )
                    }
                    <div className='mkt-entry-title' style={{ color: mktDecorates.entryInfo.fontColor }}>{mktDecorates?.memberTemp === 'threeTemp' ? item.title : entryMap[item.key].name}</div>
                    <i className='iconfont icon-chevron-right'></i>
                  </div>
                )
              })
            }
            {
              !showEntry &&
                <div data-cypid='mmgShowMoreEntry' className='more-features' onClick={() => setShowEntry(true)}>
                  <span>{i18n.t('mkt.common.moreFeatures')}</span>
                </div>
            }
          </div>
        ) : (
          <div className='mkt-entry-module'>
            {
              entryArr.slice(0, showEntry ? mktDecorates.entry.length : 7).map((item: any) => {
                const mapItem: any = entryMap[item.key]
                return mapItem && (
                  <div
                    key={item.key}
                    className='mkt-entry-item'
                    data-cypid='mmgToEntry'
                    onClick={(e: any) => handleGo(e, mapItem.path, mapItem.needLogin, mapItem.needMember)}
                  >
                    {
                      item.type === 'icon' ? (
                        <div className='mkt-entry-icon'>
                          <i style={{ color: item.color }} className={`iconfont icon-${item.value}`}></i>
                        </div>
                      ) : (
                        <div
                          className='mkt-entry-icon' style={{
                            backgroundImage: `Url(${item.value})`
                          }}
                        >
                        </div>
                      )
                    }
                    <div className='mkt-entry-title' style={{ color: mktDecorates?.entryInfo?.fontColor }}>{mapItem.name}</div>
                  </div>
                )
              })
            }
            {
              !showEntry && (
                <div
                  data-cypid='mmgShowMoreEntry'
                  className='mkt-entry-item' onClick={() => {
                    setShowEntry(true)
                  }}
                >
                  <div className='mkt-entry-icon'>
                    <i className='iconfont icon-menu'></i>
                  </div>
                  <div className='mkt-entry-title' style={{ color: mktDecorates?.entryInfo?.fontColor }}>{i18n.t('mkt.common.moreFeatures')}</div>
                </div>
              )
            }
          </div>
        )
      }
    </>
  )
}

export default observer(Entry)
